import React, { createContext, useContext, useEffect, useState } from "react";

const COLLAPSED_KEY = "thara_sidebar_collapsed";
const HIDDEN_KEY = "thara_sidebar_hidden";

const SidebarContext = createContext({
  collapsed: false,     // icon-rail (narrow) mode — chevron toggle
  hidden: false,        // fully hidden — hamburger toggle in header
  toggle: () => {},
  toggleHidden: () => {},
  setCollapsed: () => {},
  setHidden: () => {},
});

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSED_KEY) === "1";
    } catch {
      return false;
    }
  });

  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(HIDDEN_KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSED_KEY, collapsed ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [collapsed]);

  useEffect(() => {
    try {
      localStorage.setItem(HIDDEN_KEY, hidden ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [hidden]);

  const toggle = () => setCollapsed((c) => !c);
  const toggleHidden = () => setHidden((h) => !h);

  return (
    <SidebarContext.Provider value={{ collapsed, hidden, toggle, toggleHidden, setCollapsed, setHidden }}>
      {children}
    </SidebarContext.Provider>
  );
}

export const useSidebar = () => useContext(SidebarContext);
